import moment from 'moment';

export const getPeriodDaysCount = period => {
    const dayFrom = moment(period[0]);
    const dayTo = moment(period[1]);

    return dayTo.diff(dayFrom, 'days');
};
